<template>
  <b-col md="12">
    <section class="services" v-if="confirm.bookingVoucher.services_included.length">
      <p class="services__title">Servizi inclusi</p>
      <div class="services__wrap">
        <ul class="services__list">
          <li
            class="services__item"
            v-for="(service, service_index) in confirm.bookingVoucher.services_included"
            :key="_uid+service_index"
          >
            {{ service }}
          </li>
        </ul>
      </div>
    </section>
  </b-col>
</template>

<script>

export default {
  name: 'services',

  components: {
  },

  props: {
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .services {
    margin-top: $grid-gutter-width * 2;

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 20px;
    }

    &__wrap {
      padding: 15px 20px;
      background-color: $white;
      border-radius: 10px;
    }

    @media print {
      display: none;
    }

    &__list {
      margin-bottom: 0;
      padding-left: $grid-gutter-width / 2;
    }

    &__item {
      margin-bottom: $grid-gutter-width / 3;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

</style>